/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOApplyAirTicket from "./DTOApplyAirTicket";
import ApplyAirTicketPresenter from "./ApplyAirTicketPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { claimService } from "../../../../api/services/claimService";
import {
  setAirticketLaoder,
  setAllAirTickets,
} from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketsSlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
}

const ApplyAirTicketController = ({
  isModalOpen,
  closeModal,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const store_airTickets: any = useAppSelector(
    (state) => state.airTicketsSlice.airTickets
  );
  const store_airTickets_history: any = useAppSelector(
    (state) => state.airTicketHistorySlice.airTicketHistory
  );
  const isLoading: any = useAppSelector((state) => state.LoaderSlice.Loading);

  const [ticketsType, setTicketsType] = useState([]);
  const [allCountries, setAllCountries] = useState([]);
  const [benefitStatus, setBenefitStatus] = useState("");

  const getData = (data: any) => {
    applyAirTicket(data);
  };

  const getTicketsTypeCallBack = (data: any) => {
    setTicketsType(data);
  };
  const getBenefitStatusCallBack = (data: string) => {
    setBenefitStatus(data);
  };
  const getAllCountriesCallBack = (data: any) => {
    setAllCountries(data);
  };

  async function applyAirTicket(data: any) {
    if (selector) {
      const empId: any = selector.emp_id;
      const formData: any = new FormData();
      formData.append("emp_id", empId);
      formData.append("trip_type_id", data?.trip_type_id);
      formData.append("applicant", data?.applicant);
      formData.append("applicantID", data?.applicantID);

      formData.append("ticket_type", data?.ticket_type);
      formData.append("is_restricted", data?.is_restricted);
      formData.append(
        "destination",
        data?.destination ? data?.destination : ""
      );
      formData.append("travel_date", data?.travelDate ? data?.travelDate : "");
      formData.append("return_date", data?.returnDate ? data?.returnDate : "");
      if (data?.newattachement) {
        formData.append("attachment", data?.attachment ? data?.attachment : "");
      }
      formData.append(
        "accomodation",
        data?.accomodation ? data?.accomodation : ""
      );

      formData.append("remarks", data?.remarks ? data?.remarks : "");
      formData.append("amount", data?.amount ? data?.amount : "");
      formData.append("locale", localStorage.getItem("emplang"));

      await claimService
        .applyAirticket(formData)
        .then((response: any) => {
          if (response.response == "success") {
            const tempData = [...store_airTickets];
            const tempHistory = [...store_airTickets_history];
            if (response?.data?.status == 0) {
              tempData.push(response?.data);
              dispatch(setAllAirTickets(tempData));
            } else {
              tempHistory.push(response?.data);
              dispatch(setAllAirTicketHistory(tempHistory));
            }
            toast.success(t("Ticket Added Successfully"));
            refreshData();
          }
        })
        .catch((err) => {
          const _errors = err?.response?.data?.errors
            ? Object.keys(err?.response?.data?.errors)
            : err?.response?.data?.data;
          toast.error(
            err?.response?.data?.errors
              ? `${_errors.toString().toUpperCase()} Required!`
              : err?.response?.data?.data
          );
        });
    }
  }

  const refreshData = async () => {
    dispatch(setAirticketLaoder(true));
    const response = await claimService.getAllAirTickets(
      selector.emp_id,
      selector.company_id
    );
    if (response) {
      dispatch(setAllAirTickets(response?.data));
      dispatch(setAirticketLaoder(false));
      closeModal();
    } else {
      dispatch(setAirticketLaoder(false));
      closeModal();
    }
    // history
    dispatch(setClaimTicketLoader(true));
    const resp = await claimService.getAllClaimHistory(
      selector.emp_id,
      selector.company_id
    );
    if (resp) {
      const air_tickets_history = resp?.data?.air_tickets;
      const claims_history = resp?.data?.claims;

      dispatch(setAllAirTicketHistory(air_tickets_history));
      dispatch(setAllClaimHistory(claims_history));
      dispatch(setClaimTicketLoader(false));
    } else {
      dispatch(setClaimTicketLoader(false));

      return;
    }
  };
  return (
    <>
      <DTOApplyAirTicket
        setTicketsType={getTicketsTypeCallBack}
        setAllCountries={getAllCountriesCallBack}
        setBenefitStatus={getBenefitStatusCallBack}
      />

      <ApplyAirTicketPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allTripTypes={ticketsType}
        allCountries={allCountries}
        benefitStatus={benefitStatus}
        isLoading={isLoading}
        trans={t}
        i18n={i18n}
      />
    </>
  );
};

export default ApplyAirTicketController;
